import { render, staticRenderFns } from "./Taints.vue?vue&type=template&id=4e2bf449&"
import script from "./Taints.vue?vue&type=script&lang=js&"
export * from "./Taints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports